export default __webpack_public_path__ + "static/media/default.8c039e93fe1fd4e6714d19c679566840.png";